/* eslint-disable */ import { assertNumber, distanceDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const rectangularPlateComponents = [
    attachComponent.withComponent(distanceDimensionComponent, 'horizontalLength', true).withEntity('RectangularPlate').attach(memoEval((self)=>[
            self.horizontalLength,
            self.$minHorizontalLength,
            self.$maxHorizontalLength
        ], (horizontalLength, $minHorizontalLength, $maxHorizontalLength)=>({
            value: horizontalLength,
            min: $minHorizontalLength,
            max: $maxHorizontalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            horizontalLength: state.value
        };
    }),
    attachComponent.withComponent(distanceDimensionComponent, 'verticalLength', true).withEntity('RectangularPlate').attach(memoEval((self)=>[
            self.verticalLength,
            self.$minVerticalLength,
            self.$maxVerticalLength
        ], (verticalLength, $minVerticalLength, $maxVerticalLength)=>({
            value: verticalLength,
            min: $minVerticalLength,
            max: $maxVerticalLength
        })), (state)=>{
        assertNumber(state.value);
        return {
            verticalLength: state.value
        };
    })
];

//# sourceMappingURL=rectangular-plate.js.map